<template>
  <div class="news-scroll-container">
    <div class="news-scroll-track" ref="scrollContainer">
      <div class="news-card-wrap" v-for="(item, key) in data" :key="key">
        <v-hover v-slot="{ hover }">
          <v-card class="news-card rounded-xl" :elevation="hover ? 6 : 1" @click="viewModal = true; selected = item"
            style="cursor: pointer; transition: all 0.25s ease;"
            :style="{ transform: hover ? 'translateY(-3px)' : 'none' }">
            <!-- Image -->
            <div style="position: relative; overflow: hidden; border-radius: 12px 12px 0 0;">
              <v-img cover
                :src="item.avatar ? (item.avatar.includes('pdf') ? '/static/file_placeholder.jpg' : item.avatar) : '/static/file_placeholder.jpg'"
                height="140px" style="transition: transform 0.3s ease;"
                :style="{ transform: hover ? 'scale(1.05)' : 'scale(1)' }"></v-img>
              <!-- overlay on hover -->
              <div class="news-card__overlay pa-3 d-flex align-end" :style="{ opacity: hover ? 1 : 0 }">
                <v-btn small rounded dark depressed color="rgba(255,255,255,0.2)"
                  style="backdrop-filter: blur(4px); font-size: 11px;">
                  <v-icon left x-small>mdi-eye</v-icon>Xem
                </v-btn>
              </div>
            </div>

            <div class="pa-3">
              <!-- Category -->
              <v-chip x-small :color="`${item.contentCategoryCodeNavigationColor} lighten-4`"
                :text-color="item.contentCategoryCodeNavigationColor" class="mb-2 font-weight-bold"
                style="font-size: 10px;">
                {{ item.contentCategoryCodeNavigationTitle }}
              </v-chip>

              <!-- Title -->
              <div class="news-card__title font-weight-bold mb-2">
                {{ item.title }}
              </div>

              <!-- Author -->
              <div class="d-flex align-center" style="gap: 6px;">
                <v-avatar size="22">
                  <v-img :src="item.createdByNavigationAvatar" sizes="22">
                    <template v-slot:placeholder>
                      <v-icon size="22" color="grey lighten-1">mdi-account-circle</v-icon>
                    </template>
                  </v-img>
                </v-avatar>
                <div>
                  <div class="news-card__author">{{ item.createdByNavigationName }}</div>
                  <div class="news-card__date">{{ $formatter.formatDate(item.createdAt, "DD/MM/YYYY") }}</div>
                </div>
              </div>
            </div>
          </v-card>
        </v-hover>
      </div>
    </div>

    <!-- Detail dialog -->
    <v-dialog v-model="viewModal" width="1200px">
      <v-card v-if="selected" class="rounded-xl">
        <v-card-title class="text-subtitle-1 font-weight-bold" style="word-break: normal;">
          {{ selected?.title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-img v-if="!selected.avatar?.includes('.pdf')" :src="selected.avatar"></v-img>
        <iframe v-else :src="selected.avatar" style="width:100%; height:650px; border:none;"></iframe>
        <v-card-text class="pt-3">
          <span v-html="selected?.brief"></span>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn text @click="viewModal = false">Đóng</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "media",
  props: ["data"],
  data() {
    return {
      viewModal: false,
      selected: null
    }
  },
  methods: {
    scrollLeft() {
      this.$refs.scrollContainer.scrollBy({
        left: -320,
        behavior: "smooth"
      });
    },
    scrollRight() {
      this.$refs.scrollContainer.scrollBy({
        left: 320,
        behavior: "smooth"
      });
    },
  },
}
</script>

<style scoped>
.news-scroll-container {
  width: 100%;
  overflow: hidden;
}

.news-scroll-track {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  padding: 4px 2px 8px;
}

.news-scroll-track::-webkit-scrollbar {
  display: none;
}

.news-card-wrap {
  flex: 0 0 280px;
}

.news-card {
  width: 280px;
}

.news-card__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.1));
  transition: opacity 0.25s ease;
}

.news-card__title {
  font-size: 13px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #212121;
}

.news-card__author {
  font-size: 11px;
  font-weight: 600;
  color: #424242;
  line-height: 1.2;
}

.news-card__date {
  font-size: 10px;
  color: #9e9e9e;
}
</style>